// src/components/Toaster/toasterReducer.js
import { TOASTER_SHOW, TOASTER_HIDE } from "./toasterActions";

const initialState = {
    open: false,
    heading: "",
    message: "",
    variant: "success", // 'success' | 'error' | 'info' | 'warning'
};

export default function toasterReducer(state = initialState, action) {
    switch (action.type) {
        case TOASTER_SHOW:
            return {
                ...state,
                open: true,
                heading: action.payload.heading,
                message: action.payload.message,
                variant: action.payload.variant,
            };
        case TOASTER_HIDE:
            return {
                ...state,
                open: false,
                heading: "",
                message: "",
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/components/Toaster/toasterReducer.js